import { createSlice } from "@reduxjs/toolkit";

export const organizationalUnitsSlice = createSlice({
  name: "organizationalUnits",
  initialState: {
    isFetchingOrganizationalUnits: false,
    organizationalUnits: [],
    fetchOrganizationalUnitsError: null,

    // YAML
    isGeneratingYaml: false,
    generateYamlResponse: null,
    generateYamlError: null,

    // Event Insight YAML
    isGeneratingEventInsightYaml: false,
    generateEventInsightYamlResponse: null,
    generateEventInsightYamlError: null,

    // check stack and account status 
    isCheckingStackStatus : false,
    stackStatusSuccessResponse : null,
    stackStatusError : null,

    isCheckingAcocuntActivity : false,
    accountActivitySuccess : null,
    accountActivityError : null,

  },
  reducers: {
    // 🔄 GET Org Units
    getOrganizationalUnits: (state) => {
      state.isFetchingOrganizationalUnits = true;
      state.fetchOrganizationalUnitsError = null;
    },
    getOrganizationalUnitsSuccess: (state, action) => {
      state.isFetchingOrganizationalUnits = false;
      state.organizationalUnits = action.payload;
    },
    getOrganizationalUnitsFailure: (state, action) => {
      state.isFetchingOrganizationalUnits = false;
      state.organizationalUnits = [];
      state.fetchOrganizationalUnitsError =
        typeof action.payload === "string"
          ? action.payload
          : action.payload?.message || String(action.payload ?? "");
    },

    // 📄 POST YAML
    generateYaml: (state) => {
      state.isGeneratingYaml = true;
      state.generateYamlError = null;
      state.generateYamlResponse = null;
    },
    generateYamlSuccess: (state, action) => {
      state.isGeneratingYaml = false;
      state.generateYamlResponse = action.payload;
    },
    generateYamlFailure: (state, action) => {
      state.isGeneratingYaml = false;
      state.generateYamlError = action.payload;
    },

    resetGenerateYaml: (state) => {
      state.generateYamlResponse = null;
      state.generateYamlError = null;
    },

    // 📄 POST Event Insight YAML
    generateEventInsightYaml: (state) => {
      state.isGeneratingEventInsightYaml = true;
      state.generateEventInsightYamlError = null;
      state.generateEventInsightYamlResponse = null;
    },
    generateEventInsightYamlSuccess: (state, action) => {
      state.isGeneratingEventInsightYaml = false;
      state.generateEventInsightYamlResponse = action.payload;
    },
    generateEventInsightYamlFailure: (state, action) => {
      state.isGeneratingEventInsightYaml = false;
      state.generateEventInsightYamlError = action.payload;
    },

    resetGenerateEventInsightYaml: (state) => {
      state.generateEventInsightYamlResponse = null;
      state.generateEventInsightYamlError = null;
    },

    // ♻️ RESET
    clearFetchOrganizationalUnitsError: (state) => {
      state.fetchOrganizationalUnitsError = null;
    },
    clearOrganizationalUnits: (state) => {
      state.organizationalUnits = [];
      state.fetchOrganizationalUnitsError = null;
      
      // Reset YAML states
      state.generateYamlResponse = null;
      state.generateYamlError = null;
      state.generateEventInsightYamlResponse = null;
      state.generateEventInsightYamlError = null;
      
      state.isCheckingStackStatus = null;
      state.stackStatusSuccessResponse = null;
      state.stackStatusError = null;

      state.isCheckingAcocuntActivity = true;
      state.accountActivitySuccess = null;
      state.accountActivityError = null;
    },

    // 📄 STACK STATUS
    checkStackStatusMethod: (state) => {
      state.isCheckingStackStatus = true;
      state.stackStatusSuccessResponse = null;
      state.stackStatusError = null;
    },
    stackStatusResponseMethod: (state, action) => {
      state.isCheckingStackStatus = false;
      state.stackStatusSuccessResponse = action.payload;
    },
    stackStatusErrorMethod: (state, action) => {
      state.isCheckingStackStatus = false;
      state.stackStatusError = action.payload?.message || action.payload;
    },

    // 📄 ACCOUNT STATUS
    checkAccountActivityMethod: (state) => {
      state.isCheckingAcocuntActivity = true;
      state.accountActivitySuccess = null;
      state.accountActivityError = null;
    },
    accountActivitySuccessMethod: (state, action) => {
      state.isCheckingAcocuntActivity = false;
      state.accountActivitySuccess = action.payload;
    },
    accountActivityErrorMethod: (state, action) => {
      state.isCheckingAcocuntActivity = false;
      state.accountActivityError = action.payload?.message || action.payload;
    },

  },
});

export const {
  getOrganizationalUnits,
  getOrganizationalUnitsSuccess,
  getOrganizationalUnitsFailure,

  generateYaml,
  generateYamlSuccess,
  generateYamlFailure,
  resetGenerateYaml,

  generateEventInsightYaml,
  generateEventInsightYamlSuccess,
  generateEventInsightYamlFailure,
  resetGenerateEventInsightYaml,

  clearFetchOrganizationalUnitsError,
  clearOrganizationalUnits,

  checkStackStatusMethod,
  stackStatusResponseMethod,
  stackStatusErrorMethod,

  checkAccountActivityMethod,
  accountActivitySuccessMethod,
  accountActivityErrorMethod

  
} = organizationalUnitsSlice.actions;

export default organizationalUnitsSlice.reducer;
